import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import classes from './ArrowControl.module.css.mjs';
import { SliderControl } from './subcomponent/SliderControl/SliderControl.mjs';
import { CarouselControl } from './subcomponent/CarouselControl/CarouselControl.mjs';

const ArrowControl = polymorphicFactory(
  (props, ref) => {
    const { component = "button", variant = "carousel", className, isOnPhoto, ...rest } = props;
    const classNames = clsx("kohler-arrow-control-root", className, classes.arrowControl);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, variant === "carousel" && /* @__PURE__ */ React.createElement(CarouselControl, { ...rest, component, className: classNames, ref }), variant === "slider" && /* @__PURE__ */ React.createElement(SliderControl, { ...rest, component, isOnPhoto, className: classNames, ref }));
  }
);

export { ArrowControl };
